export default __webpack_public_path__ + "static/olczak-nowicka-42965bc4af5c16e45d2517d98e12c16e.jpg";